import { Injectable } from '@angular/core';

export interface SubMenu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
}
export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
  priv: string;
  children: SubMenu[];
}

const MENUITEMS = [
  { state: 'dispatching/fleet', type: 'link', name: 'fleetTable', icon: 'directions_bus', priv: 'rd_dispatching', children: [] },
  { state: 'dispatching/planning', type: 'link', name: 'dispatchPlanning', icon: 'alt_route', priv: 'rd_dispatching', children: [] },
  { state: 'dispatching/movements', type: 'link', name: 'dispatchMovements', icon: 'sync_alt', priv: 'rd_dispatching', children: [] },
  { state: 'dispatching/evaluation', type: 'link', name: 'travelEvaluation', icon: 'fact_check', priv: 'rd_dispatching', children: [] },
  { state: 'dispatching/history', type: 'link', name: 'dispatchHistory', icon: 'history', priv: 'rd_dispatching', children: [] }
];

@Injectable()
export class MenuItemsDispatching {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
